import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { DumbClubAvatar } from '#src/components/club/DumbClubAvatar/index.tsx';
import { FlagAvatar } from '#src/components/country/FlagAvatar/index.tsx';
import { useIntlContext } from '#src/contexts/intl/index.ts';
import { isType } from '#src/lib/gql/index.ts';

import type { TeamAvatar_team } from './__generated__/index.graphql.ts';
import { messages } from './i18n.ts';

type Props = {
  withTooltip?: boolean;
  className?: string;
  team: Nullable<TeamAvatar_team>;
  size?: number;
};

export const TeamAvatar = ({ team, withTooltip, className, size }: Props) => {
  const { formatMessage } = useIntlContext();
  if (isType(team, 'NationalTeam'))
    return (
      <FlagAvatar
        className={className}
        country={team.country}
        imageRes={64}
        withTooltip={withTooltip}
        size={size}
      />
    );
  return (
    <DumbClubAvatar
      className={className}
      club={
        team || {
          name: formatMessage(messages.noneName),
          avatarUrl: null,
        }
      }
      withTooltip={withTooltip}
      size={size}
    />
  );
};

TeamAvatar.fragments = {
  team: gql`
    fragment TeamAvatar_team on Team {
      ... on TeamInterface {
        slug
        name
        avatarUrl: pictureUrl(derivative: "avatar")
      }
      ... on NationalTeam {
        slug
        country {
          slug
          name
        }
      }
    }
  ` as TypedDocumentNode<TeamAvatar_team>,
};
